/*jshint esversion:6 */
import React from "react";
import Moment from "moment";
import ATable from "../common/table";
import Constants from "../../configurations/constants";
import RenderObjects from "../common/ObjectRenderer";
import Modal from "../common/modal";

class ReportsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedRow: null
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  showModal(data) {
    this.setState({
      showModal: true,
      selectedRow: data
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      selectedRow: null
    });
  }

  render() {
    const modalStyle = {
      ovelay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "180px",
        zIndex: "1000"
      }
    };
    const columns = [
      {
        header: "S/N",
        width: 50,
        render: row => <div>{this.props.paginatedCallback(row.viewIndex)}</div>
      },
      {
        header: "Search Criteria",
        render: row => {
          let searchCriteria;
          if (row.row.reportParams) {
            const reportObject = JSON.parse(row.row.reportParams);
            const { pageNum, pageSize, ...reportParams } = reportObject;
            searchCriteria = (
              <div onClick={() => this.showModal(reportParams)}>
                <a className="">View Criteria</a>
              </div>
            );
          } else {
            searchCriteria = (
              <div>
                {row.row.logCode && (
                  <p>
                    <strong>Log Code: </strong>
                    {row.row.logCode}
                  </p>
                )}
                {row.row.startDate && row.row.endDate && (
                  <p>
                    <strong>Date range:</strong>
                    <br />
                    {Moment(row.row.startDate).format(
                      Constants.DATE_FORMAT_LONG
                    )}{" "}
                    -{" "}
                    {Moment(row.row.endDate).format(Constants.DATE_FORMAT_LONG)}
                  </p>
                )}
              </div>
            );
          }
          return searchCriteria;
        },
        width: 250
      },
      {
        header: "File Type",
        render: row => {
          let reportType;
          if (row.row.reportType) {
            reportType = row.row.reportType;
          } else if (row.row.reportParams) {
            const reportParamsObject = JSON.parse(row.row.reportParams);
            reportType = reportParamsObject.reportType;
          }
          return reportType;
        },
        width: 90
      },
      {
        header: "Status",
        accessor: "status",
        render: row => {
          return row.row.status;
        },
        width: 90
      },
      {
        header: " File name",
        accessor: "fileName",
        render: row => {
          return row.row.fileName
            ? row.row.fileName
            : "-- Report not available --";
        }
      },
      {
        header: "Created By",
        accessor: "createdBy",
        render: row => {
          return row.row.createdBy;
        }
      },
      {
        header: "Created On",
        accessor: "createdOn",
        render: row => {
          return Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG);
        }
      },
      {
        header: "",
        accessor: "action",
        render: row => {
          const dateDifference = Moment().diff(Moment(row.row.createdOn));
          const isValidPending =
            dateDifference < Constants.SETTLEMENT_REPORT_MAXTIME;
          return (
            <div>
              {row.row.status.toLowerCase() ===
              Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ? (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.downloadReports(row.row.fileName);
                  }}
                >
                  Download
                </button>
              ) : (row.row.status.toLowerCase() ===
                  Constants.SETTLEMENT_REPORT_STATUS.PENDING ||
                  row.row.status.toLowerCase() ===
                    Constants.SETTLEMENT_REPORT_STATUS.PROCESSING) &&
                isValidPending ? (
                <span className="text-info">In progress...</span>
              ) : (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.retryReportGeneration(row.row.id);
                  }}
                >
                  Retry
                </button>
              )}
            </div>
          );
        }
      }
    ];

    return (
      <div>
        <ATable
          className="-striped -highlight"
          tableData={this.props.reports}
          noDataText={
            this.props.reportType
              ? `No ${this.props.reportType} reports found`
              : "Select a report type"
          }
          columns={columns}
          onChange={this.props.onTableChange || null}
          manual
          {...this.props}
        />
        <Modal
          title="Report parameters"
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          style={modalStyle}
        >
          <RenderObjects
            className="dispute-col"
            objectToConv={this.state.selectedRow}
          />
        </Modal>
      </div>
    );
  }
}

export default ReportsTable;



// WEBPACK FOOTER //
// ./src/components/reports/ReportsTable.js